export const isNumeric = (value: any) => /^\d([ -]?\d)*$/.test(value)
